export const CLOSE_BUTTON_TEXT = `Закрыть`;
export const SOUND_BUTTON_TEXT = `Управление звуком`;
